import { render, staticRenderFns } from "./ComparisonGrid.vue?vue&type=template&id=15aedfe6&scoped=true"
import script from "./ComparisonGrid.vue?vue&type=script&lang=js"
export * from "./ComparisonGrid.vue?vue&type=script&lang=js"
import style0 from "./ComparisonGrid.vue?vue&type=style&index=0&id=15aedfe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aedfe6",
  null
  
)

export default component.exports